<template>
  <div class="container-fluid row">
    <div v-if="loading">
      <clip-loader :loading="loading" :color="color" :size="size"></clip-loader>
    </div>
    <div v-else>
      <div class="mt-5">
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 mt-3">
              <h5 class="card-title">ต้นแบบการนำเข้าข้อมูลการคุมสอบ</h5>
            </div>
            <div class="col-md-12">
              <button class="btn btn-sm btn-info">
                <div><a :href="prototype" style="color:white;text-decoration: none;"> ดาวน์โหลดต้นแบบ</a></div>
              </button>

            </div>
            <div class="col-md-3 mt-5">
              <label for="exampleInputEmail1" class="form-label">เลือกไฟล์สำหรับบันทึกข้อมูลลงระบบ</label>
              <input type="file" accept=".xlsx, .xls" @change="onChangeC1" class="form-control-file" id="excelfile" />
              <button @click="save()" type="button" class="btn btn-success btn-sm mt-3">
                บันทึกข้อมูลลงในระบบ
              </button>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <h5 class="card-title">ค้นหาข้อมูล</h5>
          </div>
          <div class="col-md-3 mt-3">
            <label for="exampleFormControlSelect1">ปีการศึกษา</label>
            <select v-model="filter.year" class="form-select form-control-sm" id="exampleFormControlSelect1">
              <option v-for="(s, i) in year" v-bind:value="s.id" :key="i + 1">
                {{ s.name }}
              </option>
            </select>
          </div>
          <div class="col-md-3 mt-3">
            <label for="exampleFormControlSelect1">เทอม</label>
            <select v-model="filter.term" class="form-select form-control-sm" id="exampleFormControlSelect1">
              <option v-for="(s, i) in term" v-bind:value="s.id" :key="i + 1">
                {{ s.name }}
              </option>
            </select>
          </div>
          <div class="col-md-3 mt-3 mb-3">
            <label for="exampleFormControlSelect1">ประเภทการสอบ</label>
            <select v-model="filter.exam_type" class="form-select form-control-sm" id="exampleFormControlSelect1">
              <option v-for="(s, i) in exam_type" v-bind:value="s.name" :key="i + 1">
                {{ s.nameTH }}
              </option>
            </select>
          </div>
          <div class="col-md-3 mt-3 mb-3">
            <label for="exampleFormControlSelect1">เลือกวันที่สอบ</label>
            <input type="date" id="examDate" class="form-control form-control-sm" v-model="filter.exam_date"
              @change="formatDateFilter" />
          </div>
          <div class="col-md-3 mt-3 mb-3">
            <label for="exampleFormControlSelect1">รายวิชา</label>
            <input type="text" id="examDate" class="form-control form-control-sm" v-model="filter.subject" />
          </div>
          <div class="col-md-3 mt-3 mb-3">
            <label for="exampleFormControlSelect1">อาจารย์ผู้สอน</label>
            <input type="text" id="examDate" class="form-control form-control-sm" v-model="filter.instructor" />
          </div>
          <div class="col-md-3 mt-3 mb-3">
            <label for="exampleFormControlSelect1">คณะ</label>
            <select v-model="filter.faculty_id" class="form-select form-control-sm" id="exampleFormControlSelect1"
              @change="getCoursesByFaculty">
              <option v-for="(s, i) in faculty" v-bind:value="s.id" :key="i + 1">
                {{ s.nameTH }}
              </option>
            </select>
          </div>
          <div class="col-md-3 mt-3 mb-3">
            <label for="exampleFormControlSelect1">หลักสูตร</label>
            <select v-model="filter.course_id" class="form-select form-control-sm" id="exampleFormControlSelect1"
              @change="getFacultyByCourses">
              <option v-for="(s, i) in courselist" v-bind:value="s.id" :key="i + 1">
                {{ s.nameTH }}
              </option>
            </select>
          </div>

          <div class="col-md-3">
            <button @click="search()" type="button" class="btn btn-success btn-sm">
              ค้นหา
            </button>&nbsp;
            <button @click="clear()" type="button" class="btn btn-danger btn-sm">
              ล้างค่าการค้นหา
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-12 mt-5" style="margin: 5px" v-if="ExaminationScheduleAllList.length > 0">
        <div v-for="(group, index) in ExaminationScheduleAllList" :key="index" class="mb-4 border rounded">
          <div class="p-2 bg-secondary text-white d-flex justify-content-between align-items-center"
            style="cursor: pointer;">
            <strong>ปี {{ group.term }}/{{ group.year }}
              ({{ group.exam_type === 'M' ? 'Midterm' : group.exam_type === 'F' ? 'Final' : '' }})
            </strong>
            <span @click="toggleShow(index)">{{ group.show ? '▲ ซ่อน' : '▼ แสดง' }}</span>
            <a @click="deletedata(group)">
              <button type="button" class="btn btn-danger btn-sm" data-bs-toggle="modal" data-bs-target="#DeleteStatus">
                <i class="fa fa-trash"></i></button></a>
          </div>

          <!-- <div class="collapse" id="collapseExample"> -->
          <div class="table-responsive" v-show="group.show">
            <table class="table table-bordered mt-2">
              <thead>
                <tr style="text-align: center">
                  <th scope="col" style="background-color: #C4996C">ลำดับที่</th>
                  <th scope="col" style="background-color: #C4996C">
                    ปีการศึกษา
                  </th>
                  <th scope="col" style="background-color: #C4996C">
                    เทอม
                  </th>
                  <th scope="col" style="background-color: #C4996C">
                    รหัสรายวิชา
                  </th>
                  <th scope="col" style="background-color: #C4996C">ชื่อรายวิชา</th>
                  <th scope="col" style="background-color: #C4996C">หน่วยกิต</th>
                  <th scope="col" style="background-color: #C4996C">หมู่เรียน</th>
                  <th scope="col" style="background-color: #C4996C">กลุ่ม</th>
                  <th scope="col" style="background-color: #C4996C">อาจารย์ผู้สอน</th>
                  <th scope="col" style="background-color: #C4996C">ชาวต่างชาติ</th>
                  <th scope="col" style="background-color: #C4996C">ตำแหน่งทางวิชาการ</th>
                  <th scope="col" style="background-color: #C4996C">ผู้รับผิดชอบรายวิชา</th>
                  <th scope="col" style="background-color: #C4996C">เพศ</th>
                  <th scope="col" style="background-color: #C4996C">EXAM_DATE</th>
                  <th scope="col" style="background-color: #C4996C">EXAM_TIME_FROM</th>
                  <th scope="col" style="background-color: #C4996C">EXAM_TIME_TO</th>
                  <th scope="col" style="background-color: #C4996C">EXAM_TYPE</th>
                  <th scope="col" style="background-color: #C4996C">คณะ</th>
                  <th scope="col" style="background-color: #C4996C">หลักสูตร</th>
                  <th scope="col" style="background-color: #C4996C">จำนวนนิสิต</th>
                  <th scope="col" style="background-color: #C4996C">ห้องสอบ</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(s, i) in group.detail" :key="s.id">
                  <th scope="row" style="text-align: center">{{ i + 1 }}</th>
                  <th scope="row" style="text-align: center">{{ s.year }}</th>
                  <th scope="row" style="text-align: center">{{ s.term }}</th>
                  <th scope="row" style="text-align: center">{{ s.code }}</th>
                  <th scope="row" style="text-align: center">{{ s.major_name }}</th>
                  <th scope="row" style="text-align: center">{{ s.credit }}</th>
                  <th scope="row" style="text-align: center">{{ s.section }}</th>
                  <th scope="row" style="text-align: center">{{ s.group_m }}</th>
                  <th scope="row" style="text-align: center">{{ s.fullname }}</th>
                  <th scope="row" style="text-align: center">{{ s.foreigner_status }}</th>
                  <th scope="row" style="text-align: center">{{ s.academic_positions }}</th>
                  <th scope="row" style="text-align: center"><span v-if="s.responsible_status">ใช่</span><span
                      v-else>ไม่ใช่</span></th>
                  <th scope="row" style="text-align: center">{{ s.sex }}</th>
                  <th scope="row" style="text-align: center">{{ formatDate(s.exam_date) }}</th>
                  <th scope="row" style="text-align: center">{{ parseFullTimeToMinutes(s.exam_time_from) }}</th>
                  <th scope="row" style="text-align: center">{{ parseFullTimeToMinutes(s.exam_time_to) }}</th>
                  <th scope="row" style="text-align: center">{{ s.exam_type }}</th>
                  <th scope="row" style="text-align: center">{{ s.faculty_name }}</th>
                  <th scope="row" style="text-align: center">{{ s.course_name }}</th>
                  <th scope="row" style="text-align: center">{{ s.number }}</th>
                  <th scope="row" style="text-align: center">{{ s.room_name }}</th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>


        <div class="modal fade" id="DeleteStatus" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">ยืนยันการลบข้อมูล</h5>
              </div>
              <div class="modal-footer mt-3">
                <button type="button" class="btn btn-danger btn-sm" @click="deleteall()">
                  ลบข้อมูล
                </button>
                <button id="closeddeleteuser" type="button" class="btn btn-secondary  btn-sm" data-bs-dismiss="modal">
                  ปิด
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import readXlsxFile from "read-excel-file";
// import axios from 'axios';
import LinkService from "../services/LinkService";
import CourseService from "../services/CourseService";
import ProctorService from "../services/ProctorService";
import MajorService from "../services/MajorService";
import SubjectService from "../services/SubjectService";
import AcademicPositionService from "../services/AcademicPositionService";
import FacultyService from "../services/FacultyService";
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import YearTermTypeService from "../services/YearTermTypeService";
import RoomService from "../services/RoomService";
import ExaminationScheduleService from "../services/ExaminationScheduleService";
import ExaminerService from "../services/ExaminerService";
import SubjectResponsiblePersonService from "../services/SubjectResponsiblePersonService";
import MajorDescService from "../services/MajorDescService";

export default {
  name: "Nav",
  props: {
    msg: String,
  },
  components: {
    ClipLoader
  },
  data() {
    return {
      color: '#5bc0de',
      size: '50px',
      prototype: '',
      faculty: [],
      course: [],
      courselist: [],
      proctor: [],
      major: [],
      subjects: [],
      academic_positions: [],
      year: [],
      term: [],
      exam_type: [],
      filter: { year: '', term: '', exam_type: '', exam_date: '', faculty_id: '', course_id: '', subject: '', instructor: '' },
      subjectdisplay: [],
      loading: false,
      year_term_type: [],
      roomlist: [],
      ExaminationScheduleList: [],
      SubjectResponsiblePersonList: [],
      Examiner: [],
      ExaminationScheduleAllList: [],
      deletedatavalue: {},
      file: ''
    };
  },
  mounted() {
    this.prototype = LinkService.getLink() + '/uploads/ต้นแบบการนำเข้าข้อมูลการคุมสอบ.xlsx';
    this.getFaculty()
    this.getCourses()
    this.getMajors();
    this.getRooms();
    this.getAcademicPosition()
    // this.getSubjectsDisplay();
    this.getlistyear()
    this.getYearTermType()
    this.getSubjectResponsiblePersonList()
    this.getExaminar()
    this.getAll()

  },
  methods: {
    deletedata(data) {
      console.log(data);

      this.deletedatavalue = { year: data.year, term: data.term, exam_type: data.exam_type }
    },
    deleteall() {
      ExaminationScheduleService.deleteExaminationSchedulel(this.deletedatavalue)
      document.getElementById("closeddeleteuser").click();
      location.reload();

    },
    getAll() {
      ExaminationScheduleService.getAll(this.filter).then((res) => {
        console.log(res.data);
        this.ExaminationScheduleAllList = res.data
        this.ExaminationScheduleAllList.forEach(group => {
          this.$set(group, 'show', false); // ใช้ Vue.set หรือ this.$set
        });

        this.year = [...new Set(this.ExaminationScheduleAllList.map(item => item.year))] // unique years
          .sort((a, b) => b - a) // sort descending if needed
          .map(y => ({ id: y, name: y }));
        this.term = [...new Set(this.ExaminationScheduleAllList.map(item => item.term))] // unique years
          .sort((a, b) => b - a) // sort descending if needed
          .map(y => ({ id: y, name: y }));

        const examTypeMap = {
          M: { id: 1, nameTH: "Midterm", name: "M" },
          F: { id: 2, nameTH: "Final", name: "F" }
        }
        this.exam_type = [...new Set(this.ExaminationScheduleAllList.map(item => item.exam_type))]
          .map(code => examTypeMap[code])
          .filter(Boolean)
      });
    },
    getExaminar() {
      ExaminerService.getExaminers().then((res) => {
        this.Examiner = res.data;
        // console.log(this.Examiner);
      });
    },
    getSubjectResponsiblePersonList() {
      SubjectResponsiblePersonService.getSubjectResponsiblePersons().then((res) => {
        this.SubjectResponsiblePersonList = res.data;
        // console.log(this.SubjectResponsiblePersonList);
      });
    },
    getlistyear() {
      const currentYear = new Date().getFullYear() + 543;
      const startYear = 2567;

      this.year = Array.from({ length: currentYear - startYear + 1 }, (_, i) => {
        const year = startYear + i;
        return { id: year, name: year };
      });

      // console.log(this.year);
    },
    toggleGroup(index) {
      console.log(index);

      const group = this.ExaminationScheduleService[index];
      if (group.show === undefined) {
        this.$set(group, 'show', true);  // หรือ false ถ้าต้องการค่าเริ่มต้น
      } else {
        group.show = !group.show;
      }
    },
    toggleShow(index) {
      this.ExaminationScheduleAllList[index].show = !this.ExaminationScheduleAllList[index].show;
    },
    clear() {
      this.filter = { year: '', term: '', exam_type: '', exam_date: '', faculty_id: '', course_id: '', subject: '', instructor: '' }
      this.getCourses()
      this.getAll()
    },
    getFacultyByCourses() {
      const facultylist = this.course.find(c =>
        c.id === this.filter.course_id
      );
      this.filter.faculty_id = facultylist.faculty_id;
    },
    getCoursesByFaculty() {
      const courselist = this.course.filter(c =>
        c.faculty_id === this.filter.faculty_id
      );
      this.courselist = courselist;
    },
    formatDateFilter() {
      if (!this.examDate) return;
      const date = new Date(this.examDate);
      const year = date.getFullYear();
      const month = (`0${date.getMonth() + 1}`).slice(-2); // เติม 0
      const day = (`0${date.getDate()}`).slice(-2);
      this.filter.exam_date = `${year}-${month}-${day}`;
    },
    search() {
      this.getAll()
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // เดือนเริ่มจาก 0
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    parseFullTimeToMinutes(timeStr) {
      if (typeof timeStr !== 'string') return "ไม่พบเวลา";

      const parts = timeStr.split(':');
      if (parts.length < 2 || parts.length > 3) return "ไม่พบเวลา";

      const hours = parseInt(parts[0], 10);
      const minutes = parseInt(parts[1], 10);

      if (
        isNaN(hours) || isNaN(minutes) ||
        hours < 0 || hours > 23 ||
        minutes < 0 || minutes > 59
      ) {
        return "ไม่พบเวลา";
      }

      return hours * 60 + minutes;
    },
    getFaculty() {
      FacultyService.getFacultys().then((res) => {
        this.faculty = res.data;
        // console.log(this.faculty);
      });
    },
    getCourses() {
      CourseService.getCourses().then((res) => {
        this.course = res.data;
        this.courselist = res.data
        // console.log(this.course);
      });
    },
    getYearTermType() {
      YearTermTypeService.getYear_Term_Types().then((res) => {
        this.year_term_type = res.data;
        // console.log(this.year_term_type,'year_term_type');
      });
    },
    getMajors() {
      MajorService.getMajors().then((res) => {
        this.major = res.data;
        // console.log(this.major);
      });
    },
    getRooms() {
      RoomService.getRooms().then((res) => {
        this.roomlist = res.data;
        // console.log(this.major);
      });
    },
    getAcademicPosition() {
      AcademicPositionService.getAcademicPosition().then((res) => {
        this.academic_positions = res.data;
        console.log(this.academic_positions);
      });
    },
    getSubjectsDisplay() {
      SubjectService.getSubjectsDisplay(this.filter).then((res) => {
        this.subjectdisplay = res.data;
        this.subjectdisplay.forEach(group => {
          this.$set(group, 'show', false); // ใช้ Vue.set หรือ this.$set
        });
        this.year = [...new Set(this.subjectdisplay.map(item => item.year))] // unique years
          .sort((a, b) => b - a) // sort descending if needed
          .map(y => ({ id: y, name: y }));
        this.term = [...new Set(this.subjectdisplay.map(item => item.term))] // unique years
          .sort((a, b) => b - a) // sort descending if needed
          .map(y => ({ id: y, name: y }));

        const examTypeMap = {
          M: { id: 1, nameTH: "Midterm", name: "M" },
          F: { id: 2, nameTH: "Final", name: "F" }
        }
        this.exam_type = [...new Set(this.subjectdisplay.map(item => item.exam_type))]
          .map(code => examTypeMap[code])
          .filter(Boolean) // กัน null กรณีเจอ code แปลกๆ
        // console.log(this.year);
        // console.log(this.term);
        // console.log(this.exam_type);
        // console.log(this.subjectdisplay);
      });
    },
    async getSubjects() {
      const res = await SubjectService.getSubjects();
      this.subjects = res.data;
    },
    converttime(value) {
      // ถ้าไม่ตรงใน map แปลงเป็น HH:mm
      if (typeof value === "number" && value >= 0 && value < 1440) {
        const hours = Math.floor(value / 60);
        const minutes = value % 60;
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
      }

      return "ไม่พบเวลา";
    },
    async createProctor(file) {
      const res = await ProctorService.createProctor({
        fullname: file.fullname,
        foreigner_status: file.foreigner_status,
        academic_positions: file.academic_position_id,
        faculty_id: file.faculty_id,
        course_id: file.course_id,
        sex: file.sex,
        health: 1,
        status: 1
      });
      return res.data.id;

    },
    async createYearTermType(file) {
      const res = await YearTermTypeService.createYear_Term_Types({
        year: file.year,
        term: file.term,
        exam_type: file.exam_type,
      });
      return res.data.id;

    },
    async getCourseFilter(nameTH) {
      const res = await CourseService.getCourseFilter(nameTH)
      return res.data;
    },
    async getYear_Term_TypeByFilter(data) {
      const res = await YearTermTypeService.getYear_Term_TypeByFilter(data)
      return res.data;
    },
    async getProctorByFilter(data) {
      const res = await ProctorService.getProctorByFilter(data)
      return res.data;
    },
    async getMajorByFilter(data) {
      const res = await MajorService.getMajorByFilter(data)
      return res.data;
    },
    async getMajorDescByFilter(data) {
      const res = await MajorDescService.getMajorDescByFilter(data)
      return res.data;
    },
    async getRoomByFilter(data) {
      const res = await RoomService.getRoomByFilter(data)
      return res.data;
    },
    async getExaminationScheduleByFilter(data) {
      const res = await ExaminationScheduleService.getExaminationScheduleByFilter(data)
      return res.data;
    },
    async getSubjectResponsiblePersonByFilter(data) {
      const res = await SubjectResponsiblePersonService.getSubjectResponsiblePersonByFilter(data)
      return res.data;
    },
    async getExaminerByFilter(data) {
      const res = await ExaminerService.getExaminerByFilter(data)
      return res.data;
    },

    async getExaminationScheduleList(year, term, exam_type) {
      const res = await ExaminationScheduleService.getExaminationSchedules(year, term, exam_type);
      return res.data
    },
    async deleteProctorMaxS(year, term, exam_type) {
      const res = await ProctorService.deleteProctorMaxS({ year: year, term: term, exam_type: exam_type });
      console.log(res.data);

      return res.data
    },
    async getInstrutorFilter(data) {
      const res = await SubjectResponsiblePersonService.getInstrutorFilter(data);
      return res.data
    },
    async createMajor(faculty_id, file) {
      const res = await MajorService.createMajor({
        faculty_id: faculty_id,
        code: file.code,
        nameTH: file.nameTH,
        status: 1,
      });
      return res.data.id;
    },
    async createMajorDesc(major_id, file) {
      const res = await MajorDescService.createMajorDesc({
        major_id: major_id,
        credit: file.credit,
        section: file.section,
        group_m: file.group_m,
        number: file.number,
      });
      return res.data.id;
    },
    async createExaminationSchedule(file) {
      const res = await ExaminationScheduleService.createExaminationSchedule(
        file
      );
      return res.data.id;
    },
    async updateExaminationSchedule(id, file) {
      const res = await ExaminationScheduleService.updateExaminationSchedule(
        id, file
      );
      return res.data.id;
    },
    async createSubjectResponsiblePerson(file) {
      const res = await SubjectResponsiblePersonService.createSubjectResponsiblePerson(
        file
      );
      return res.data.id;
    },
    async updateSubjectResponsiblePerson(id, file) {
      const res = await SubjectResponsiblePersonService.updateSubjectResponsiblePerson(
        id, file
      );
      return res.data.id;
    },
    async createExaminer(file) {
      const res = await ExaminerService.createExaminer(
        file
      );
      return res.data.id;
    },
    async updateExaminer(id, file) {
      const res = await ExaminerService.updateExaminer(
        id, file
      );
      return res.data.id;
    },
    async createRoom(file) {
      const res = await RoomService.createRoom({
        room_name: file.room,
        count: 2
      });
      return res.data.id;
    },
    async createSubject(subject) {
      const res = await SubjectService.createSubject(subject);
      return res.data.id;
    },
    async getmaxS(year, term, examType, proctor_list, year_term_type_id) {
      // console.log(year, term, examType);
      // console.log(proctor_list, year_term_type_id);

      // รอข้อมูล subjects
      this.ExaminationScheduleList = await this.getExaminationScheduleList(year, term, examType)
      this.instructorList = await this.getInstrutorFilter({ year: year, term: term, exam_type: examType })
      console.log('this.ExaminationScheduleList', this.ExaminationScheduleList);
      console.log('this.instructorList', this.instructorList);

      await this.deleteProctorMaxS(year, term, examType);

      const Ni = this.ExaminationScheduleList.length;
      const CN = this.instructorList.length;
      const maxS = CN > 0 ? Math.ceil((2 * Ni) / CN) : 0;

      console.log(`✅ Ni: ${Ni}, CN: ${CN}, maxS: ${maxS}`);
      await this.updatemaxS(maxS, proctor_list, year_term_type_id);
      
      return maxS
    },
    async updatemaxS(maxS, list, year_term_type_id) {
      console.log('maxS', maxS);
      console.log('list', list);

      var maxSvalue;
      for (const proctor of list) {
        if (!proctor.maxS) {
          maxSvalue = maxS
        } else {
          maxSvalue = proctor.maxS
        }
        var proctormaxS = {
          year_term_type_id: year_term_type_id,
          proctor_id: proctor.instructor_id,
          maxS: maxSvalue
        }
        console.log('proctormaxS', proctormaxS);

        await ProctorService.createProctorMaxS(proctormaxS);
      }
    },
    async save() {
      if (this.file == "") {
        alert("กรุณาเลือกไฟล์ข้อมูลการคุมสอบก่อนนำเข้าข้อมูล");
      } else if (this.file.length > 0) {
        this.loading = true
        // var exist = []
        var proctor_list = []
        for (let i = 1; i < this.file.length; i++) {
          console.log(this.file[i]);

          var year = this.file[i][0]
          var term = this.file[i][1]
          var code = this.file[i][2]
          var nameTH = this.file[i][3]
          var credit = this.file[i][4]
          var section = this.file[i][5]
          var group_m = this.file[i][6]
          const fullname = this.file[i][7]
          var foreigner_status = this.file[i][8]
          var academicposition = this.file[i][9]
          var responsible = this.file[i][10]
          var sex = this.file[i][11]
          const input = new Date(this.file[i][12]);
          var exam_time_from = this.converttime(this.file[i][13])
          var exam_time_to = this.converttime(this.file[i][14])
          var exam_type = this.file[i][15]
          var course_name = this.file[i][17]
          var room = this.file[i][18]
          var number = this.file[i][19]

          var year_term_type_id = '';
          var academic_position_id = '';
          let instructor_id = '';
          var maxSvalue;
          var major_id = '';
          var major_desc_id;
          var room_id;
          var examination_id;

          const date = input.toISOString().split('T')[0];
          var exam_date = date
          var course = await this.getCourseFilter(course_name)
          // var course = this.course.find(c => c.nameTH === course_name);
          console.log('course', this.course);
          // console.log('faculty_name',course_name);
          console.log('course', course);

          var faculty_id = course[0].faculty_id;
          var course_id = course[0].id;

          var year_term_type = await this.getYear_Term_TypeByFilter({ year: year, term: term, exam_type: exam_type })
          console.log(year_term_type, 'year_term_type_filter');

          if (year_term_type.length == 0) {
            year_term_type_id = await this.createYearTermType({
              year: year,
              term: term,
              exam_type: exam_type,
            })
          } else {
            year_term_type_id = year_term_type[0].id;
          }
          console.log(year_term_type_id, 'year_term_type_id');


          var academic_position = this.academic_positions.find(c => c.name === academicposition);
          console.log(this.academic_positions, 'academic_positions');

          if (academic_position == undefined || academic_position == null) {
            academic_position_id = 2
          } else {
            academic_position_id = academic_position.id
          }

          console.log('academic_position_id', academic_position_id);

          var proctor = await this.getProctorByFilter({ fullname: fullname, faculty_id: faculty_id, course_id: course_id })
          console.log('proctor', proctor);

          if (proctor.length == 0) {
            instructor_id = await this.createProctor({
              fullname: fullname,
              foreigner_status: foreigner_status,
              academic_position_id: academic_position_id,
              faculty_id: faculty_id,
              course_id: course_id,
              sex: sex,
            })
          } else {
            instructor_id = proctor[0].id;
          }
          console.log('instructor_id', instructor_id);

          if (academic_position_id == 4) {
            maxSvalue = 3
          }
          if (!proctor_list.some(it => it.instructor_id === instructor_id)) {
            proctor_list.push({ instructor_id, maxS: maxSvalue });
          }

          var major = await this.getMajorByFilter({ code: code, nameTH: nameTH })
          console.log('major', major);

          // var major = this.major.find(c => c.code === code && c.nameTH === nameTH && c.section === section && c.group_m === group_m && c.number === number && c.credit === credit);
          // // console.log(major);
          if (major.length == 0) {
            major_id = await this.createMajor(faculty_id, { code: code, nameTH: nameTH });
          } else {
            major_id = major[0].id;
          }
          console.log('major_id', major_id);

          var major_desc = await this.getMajorDescByFilter({ section: section, group_m: group_m, number: number, credit: credit })
          console.log('major_desc', major_desc);

          // var major = this.major.find(c => c.code === code && c.nameTH === nameTH && c.section === section && c.group_m === group_m && c.number === number && c.credit === credit);
          // // console.log(major);
          if (major_desc.length == 0) {
            major_desc_id = await this.createMajorDesc(faculty_id, { code: code, nameTH: nameTH, section: section, credit: credit, group_m: group_m, number: number });
          } else {
            major_desc_id = major_desc[0].id;
          }
          console.log('major_id', major_desc_id);

          var roomlist = await this.getRoomByFilter({ room_name: room })
          console.log('roomlist', roomlist);
          if (roomlist.length == 0) {
            room_id = await this.createRoom({ room: room });
            // console.log('major_idd', major_id);
          } else {
            room_id = roomlist[0].id;
          }
          console.log('room_id', room_id);

          var ExaminationSchedule = await this.getExaminationScheduleByFilter({ year_term_type_id: year_term_type_id, major_id: major_id, exam_date: exam_date, exam_time_from: exam_time_from, room_id: room_id, major_desc_id: major_desc_id })
          console.log('ExaminationSchedule', ExaminationSchedule);
          var ExaminationScheduleList = {
            "year_term_type_id": year_term_type_id,
            "major_id": major_id,
            "exam_date": exam_date,
            "exam_time_from": exam_time_from,
            "exam_time_to": exam_time_to,
            "room_id": room_id,
            "major_desc_id": major_desc_id,
            "status": 1,
          }
          if (ExaminationSchedule.length == 0) {
            examination_id = await this.createExaminationSchedule(ExaminationScheduleList)
          } else {
            console.log('ExaminationSchedule111', ExaminationSchedule);
            // console.log('id',ExaminationSchedule[0].id);
            examination_id = ExaminationSchedule[0].id

            await this.updateExaminationSchedule(examination_id, ExaminationScheduleList)
          }
          console.log('examination_id', examination_id);

          var subject_responsible_person_list = await this.getSubjectResponsiblePersonByFilter({ examination_schedule_id: examination_id, proctor_id: instructor_id });
          console.log('subject_responsible_person_list', subject_responsible_person_list);
          var responsible_status = false
          if (responsible == 'ใช่') {
            responsible_status = true
          }
          var SubjectResponsiblePersonList = {
            "examination_schedule_id": examination_id,
            "proctor_id": instructor_id,
            "responsible_status": responsible_status
          }
          // console.log(SubjectResponsiblePersonList);

          if (subject_responsible_person_list.length == 0) {
            await this.createSubjectResponsiblePerson(SubjectResponsiblePersonList)
          } else {
            await this.updateSubjectResponsiblePerson(examination_id, SubjectResponsiblePersonList)
          }

          // if (responsible_status) {
          // var examiner = await this.getExaminerByFilter({examination_schedule_id : examination_id , proctor_id : instructor_id});

          // var Examiner = {
          //   "examination_schedule_id": examination_id,
          //   "proctor_id": instructor_id,
          //   "no": 1
          // }
          // if (examiner.length == 0) {
          //   await this.createExaminer(Examiner)
          // } else {
          //   await this.updateExaminer(examiner.id, Examiner)
          // }



          // }
          if (i === this.file.length - 1) {
            var maxS = await this.getmaxS(year, term, exam_type, proctor_list, year_term_type_id);
            console.log(maxS);
            this.loading = false
            alert("นำเข้าข้อมูลการคุมสอบสำเร็จ");
            this.file = ''
            // document.getElementById("excelfile").value = ""
            this.getAll()
          }



          // var status = this.subjects.find(c => c.instructor_id === instructor_id && c.year === year && c.term === term && c.major_id === major_id && c.exam_type === exam_type && c.section === section && c.group_m === group_m && c.number === number);


          // if (!status) {
          //   var subject = {
          //     //   faculty_id: faculty_id,
          //     // course_id: course_id,
          //     major_id: major_id,
          //     instructor_id: instructor_id,
          //     instructor_status: 1,
          //     year: year,
          //     term: term,
          //     credit: credit,
          //     section: section,
          //     number: number,
          //     exam_type: exam_type,
          //     exam_date: exam_date,
          //     exam_time_from: exam_time_from,
          //     exam_time_to: exam_time_to,
          //     room: room,
          //     group: group_m,
          //     status: 1,
          //   }
          //   var subject_id = await this.createSubject(subject)
          //   console.log('subject_id', subject_id);



          //   await this.getCourses()
          //   await this.getProctor();
          //   await this.getMajors();
          //   await this.getAcademicPosition()
          //   await this.getSubjects()

          //   if (i === this.file.length - 1) {
          // proctor_maxS
          //     var maxS = await this.getmaxS(year, term, exam_type, proctor_list, academic_position_id);
          //     console.log(maxS);

          //   }

          // } else {
          //   exist.push({
          //     faculty_id: faculty_id,
          //     course_id: course_id,
          //     major_id: major_id,
          //     instructor_id: instructor_id,
          //     year: year,
          //     term: term,
          //     section: section,
          //   });
          // }
          // await this.getCourses()
          // await this.getProctor();
          // await this.getMajors();
          // await this.getAcademicPosition()
          // await this.getSubjects()
          // if (i === this.file.length - 1) {
          //   this.loading = false
          //   // var maxS = await this.getmaxS(this.file[i][0],this.file[i][1],this.file[i][13]);
          //   // console.log(maxS);
          //   // await this.updatemaxS(maxS, proctor_list);
          //   if (exist.length > 0) {
          //     if (exist.length == this.file.length - 1) {
          //       alert(`ข้อมูลที่ซ้ำกัน ${exist.length} รายการ`);
          //     } else {
          //       alert(`นำเข้าข้อมูลสำเร็จ มีข้อมูลที่ซ้ำกัน ${exist.length} รายการ`);
          //     }
          //     console.log(exist);
          //   } else {
          //     alert("นำเข้าข้อมูลการคุมสอบสำเร็จ");
          //   }
          //   this.getSubjectsDisplay();
          //   this.file = ''
          // }

        }

      }
    },
    onChangeC1(event) {
      readXlsxFile(event.target.files[0]).then((data) => {
        this.file = data;

      });
    },
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.vertical-menu {
  background-color: #eee;
}

.vertical-menu a {
  background-color: #eee;
  color: black;
  display: block;
  padding: 12px;
  text-decoration: none;
}

.vertical-menu a:hover {
  background-color: #ccc;
}

.vertical-menu a.active {
  background-color: #04aa6d;
  color: white;
}

.card {
  margin: 0 auto;
  /* Added */
  float: none;
  /* Added */
  margin-bottom: 10px;
  /* Added */
}

body {
  background-color: gray;
}

hr {
  border: none;
  border-top: 1px solid #ccc;
  margin: 20px 0;
}

.row {
  margin-left: 0px;
  margin-right: 0px;
}
</style>
